import type { InstallDepsOptions, InstallDepsResult } from '@cli-types/next-adapter/init.js'
import { buildRemoveArgs } from './build-remove-args.js'
import { spawnAsync } from './spawn-async.js'

export async function removeDependenciesAsync({
  cwd,
  pm,
  dependencies,
  devDependencies
}: InstallDepsOptions): Promise<InstallDepsResult> {
  try {
    if (dependencies.length > 0) {
      await spawnAsync(pm, buildRemoveArgs(pm, dependencies, false), cwd)
    }

    if (devDependencies.length > 0) {
      await spawnAsync(pm, buildRemoveArgs(pm, devDependencies, true), cwd)
    }

    return { dependencies, devDeps: devDependencies, success: true, error: null }
  } catch (err) {
    return {
      dependencies,
      devDeps: devDependencies,
      success: false,
      error: err instanceof Error ? err.message : 'Remove failed'
    }
  }
}
